// Lib
import React from 'react';

// Hooks
import useUser from '../../../hooks/useUser';

import { useStyles } from './NewLabelStyles';

const NewLabel = ({ positionStatic = false }) => {
  const { isKiteUser } = useUser();

  const { classes } = useStyles({ isKiteUser, positionStatic });

  return (
    <div data-testid="new-label" className={classes.label}>
      New
    </div>
  );
};

export default NewLabel;
